export default __webpack_public_path__ + "static/media/lang_flag.4f61065a.webp";